module.exports = __webpack_public_path__ + "static/img/introduceBTypeCIcon3.89b9bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeCIcon3.png
// module id = ha5Q
// module chunks = 0